'use client';
import React, { Suspense } from 'react';
import Icon from '@/components/ui/AppIcon';
import ShopContent from './components/ShopContent';

export default function ShopPage() {
  return (
    <Suspense fallback={
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <Icon name="ArrowPathIcon" size={32} className="animate-spin text-primary" />
      </div>
    }>
      <ShopContent />
    </Suspense>
  );
}
